import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { createDashboardMainMenuConfig } from '../constants/dashboard-main-menu-config';
import { MenuItemModel } from '../../../common/models';
import { IconNames } from '../../../common/constants';
import { Router } from '@angular/router';
import { AuthFacade } from '../../../store/state/auth/auth.facade';
import { HubContextFacade } from '../../../store/state/administration/hub/context/hub-context.facade';
import { HubBrief } from '../../../store/state/administration/hub/models/hub.model';
import { ValidationRulesService } from '../../../modular-validation/validation-service';
import { LocationFeatureFlags } from '../../../modular-validation/validation';

@Component({
  selector: 'dashboard-nav-icons',
  templateUrl: './nav-icons.component.html',
  styleUrls: ['./nav-icons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavIconsComponent {
  menuStructure: MenuItemModel[] = createDashboardMainMenuConfig();
  iconNameList = IconNames;

  @Input() activeMenuItem$: BehaviorSubject<string>;

  constructor(
    private router: Router,
    public authFacade: AuthFacade,
    private hubContextFacade: HubContextFacade,
    private validationRulesService: ValidationRulesService,
  ) {}

  isFeatureFlagEnabled(flagKey: string): Observable<boolean> {
    return this.hubContextFacade.selectedHub$.pipe(
      map((hub: HubBrief) =>
        this.validationRulesService.getFeatureFlag(hub?.country, hub?.id, flagKey as keyof LocationFeatureFlags),
      ),
    );
  }

  onMenuIconClick(menuElement: MenuItemModel): void {
    if (!menuElement.children && menuElement.url) {
      const navigationString: string =
        menuElement.url === '/dashboard' ? menuElement.url : '/dashboard/' + menuElement.url;
      this.router.navigate([navigationString]);
    } else if (!menuElement.children && menuElement.externalUrl) {
      window.open(menuElement.externalUrl, '_blank');
    } else {
      this.activeMenuItem$.next(menuElement.title);
    }
  }
}
